<template>
    <div class="appointments-creating">
        <div class="appointments-creating__steps">
            <STSteps :list="steps"
                     :step="step"
                     :use-touch-move="false" />
        </div>

        <template v-if="step === 1">
            <AppointmentsUniqueCheck @continue="setSecondStep"
                                     @cancel="attemptToCancelRecord" />
        </template>
        <template v-else>
            <AppointmentsChooseDate :project-id="projectId"
                                    :client-phone="clientPhone"
                                    :client-name="clientName"
                                    :client-surname="clientSurname"
                                    @recordCreated="recordCreated"
                                    @recordNotCreated="recordNotCreated"
                                    @back="setFirstStep" />
        </template>
    </div>
</template>

<script>
import AppointmentsUniqueCheck from '@/blocks/AppointmentsBlock/AppointmentsUniqueCheck/AppointmentsUniqueCheck';
import AppointmentsChooseDate from '@/blocks/AppointmentsBlock/AppointmentsChooseDate/AppointmentsChooseDate';

export default {
    name: 'AppointmentsCreating',

    components: {
        AppointmentsChooseDate,
        AppointmentsUniqueCheck
    },

    props: {
        externalStep         : [Number, null],
        externalProjectId    : [String, null],
        externalClientPhone  : [String, null],
        externalClientName   : [String, null],
        externalClientSurname: [String, null]
    },

    data() {
        return {
            step         : 1,       // текущий шаг записи
            steps        : ['Проверка<br/>клиента', 'Выбор даты<br/>и времени'],
            projectId    : null,
            clientPhone  : null,
            clientName   : null,
            clientSurname: null
        };
    },

    created() {
        this.resetCreating();

        if (this.externalStep && this.externalProjectId && this.externalClientPhone) {
            this.step = this.externalStep;
            this.projectId = this.externalProjectId;
            this.clientPhone = this.externalClientPhone;
            this.clientName = this.externalClientName;
            this.clientSurname = this.externalClientSurname;
        }
    },

    methods: {
        setFirstStep() {
            this.step = 1;
        },

        setSecondStep(projectId = null, clientPhone = null, clientName = null, clientSurname = null) {
            this.projectId = projectId;
            this.clientPhone = clientPhone;
            this.clientName = clientName;
            this.clientSurname = clientSurname;
            this.step = 2;
        },

        attemptToCancelRecord() {
            this.resetCreating();
            this.$emit('cancel');
        },

        recordCreated(recordData) {
            this.resetCreating();
            this.$emit('recordCreated', recordData);
        },

        recordNotCreated() {
            this.resetCreating();
            this.$emit('recordNotCreated');
        },

        resetCreating() {
            this.step = 1;
            this.projectId = null;
            this.clientPhone = null;
            this.clientName = null;
            this.clientSurname = null;
        }
    }
};
</script>

<style lang="scss">
@import "AppointmentsCreating";
</style>
